import { useState, useEffect } from 'react';

const TOTAL_IMAGES = 58;

const useRandomBackground = () => {
  const [imageNumber] = useState(() => Math.floor(Math.random() * TOTAL_IMAGES) + 1);
  const [credit, setCredit] = useState(null);

  useEffect(() => {
    fetch('/backgrounds/credits.json')
      .then(res => res.json())
      .then(data => {
        const entry = data.find(c => c.file === `${imageNumber}.jpg`);
        if (entry) setCredit(entry);
      })
      .catch(() => {});
  }, [imageNumber]);

  return {
    url: `/backgrounds/${imageNumber}.jpg`,
    credit,
  };
};

export default useRandomBackground;
